import { createIcon } from '@chakra-ui/icons';

export const Dot = createIcon({
  displayName: 'Dot',
  viewBox: '0 0 10 11',
  path: <circle cx="5" cy="5.04001" r="5" fill="currentColor" />,
});
